import {createSlice} from "@reduxjs/toolkit";

export const app = createSlice({
    name: 'app',
    initialState: {
        token: '',
        isAuthenticated: false
    },
    reducers: {
        setToken: (state, {payload}) => {
            state.token = payload.value
        },
        setAuthenticatedStatus: (state, {payload}) => {
            state.isAuthenticated = payload.value
        },
    }
})


export const { setToken, setAuthenticatedStatus } = app.actions

export default app.reducer
